export enum BUTTON_ACTIONS {
  EDIT_MODE = 'edit',
  SHOW_ALL_MODE = 'show_all',
  CONTEXT_LAUNCH = 'contextLaunch',
  EVENT_PANEL = 'open_event',
  NAVIGATE_URL = 'navigate_url'
  }
